import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "px-[34px] pb-[120px] w-full max-w-[600px] mx-auto" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center py-10"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center text-white/70 py-10 font-sourcesanspro-regular"
}
const _hoisted_5 = {
  key: 2,
  class: "text-white space-y-4"
}
const _hoisted_6 = { class: "rounded backdrop-blur-xl bg-white/10 p-4" }
const _hoisted_7 = { class: "text-xs2 text-white/60 uppercase tracking-wide font-sourcesanspro-semibold" }
const _hoisted_8 = { class: "text-l2 font-sourcesanspro-semibold mt-1" }
const _hoisted_9 = { class: "text-sm2 font-sourcesanspro-regular mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "ml-2 px-2 py-0.5 rounded bg-red-600 text-white text-xs2 font-sourcesanspro-semibold"
}
const _hoisted_11 = {
  key: 0,
  class: "mt-3 text-white/90 font-sourcesanspro-regular text-sm2"
}
const _hoisted_12 = {
  key: 0,
  class: "rounded backdrop-blur-xl bg-white/10 p-4"
}
const _hoisted_13 = { class: "font-sourcesanspro-semibold text-base2 mb-3" }
const _hoisted_14 = { class: "space-y-3 border-l border-white/20 pl-4" }
const _hoisted_15 = { class: "text-xs2 text-white/60 font-sourcesanspro-regular" }
const _hoisted_16 = { class: "text-sm2 font-sourcesanspro-semibold" }

import { IonContent, IonFooter, IonIcon, IonRefresher, IonRefresherContent, RefresherCustomEvent, IonSpinner } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import NavigationBar from '@/shared/components/ui/NavigationBar.vue';
import TopBar from '@/shared/components/TopBar.vue';
import useSafety from '@/modules/safety/composables/useSafety';
import BackButton from '@/shared/components/BackButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MyReportDetailPage',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const incidentId = Number(route.params.id);

const { getReport } = useSafety();
const { report, isFetchingReport, refetchReport } = getReport(incidentId);

const onRefresh = async (ev: RefresherCustomEvent) => {
	await refetchReport();
	ev.target.complete();
};

const formatDate = (iso: string) => new Date(iso).toLocaleString();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRefresher), {
          class: "mt-8",
          slot: "fixed",
          onIonRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRefresherContent))
          ]),
          _: 1
        }),
        _createVNode(TopBar, { class: "px-[34px]" }, {
          left: _withCtx(() => [
            _createVNode(BackButton, { to: "/safety/my-reports" })
          ]),
          center: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('safety.my_reports')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          (_unref(isFetchingReport) && !_unref(report))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(IonSpinner), { name: "crescent" })
              ]))
            : (!_unref(report))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('safety.report_not_found')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)(`safety.types.${_unref(report).type}`)), 1),
                    _createElementVNode("div", _hoisted_8, "#" + _toDisplayString(_unref(report).public_code), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_unref(t)(`safety.status.${_unref(report).status}`)) + " ", 1),
                      (_unref(report).priority === 'p1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "P1"))
                        : _createCommentVNode("", true)
                    ]),
                    (_unref(report).description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(report).description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  ((_unref(report).timeline?.length ?? 0) > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('safety.timeline')), 1),
                        _createElementVNode("ol", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(report).timeline ?? [], (event, idx) => {
                            return (_openBlock(), _createElementBlock("li", { key: idx }, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(formatDate(event.created_at)), 1),
                              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)(`safety.timeline_kind.${event.kind}`)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(NavigationBar, { "item-active": "safety" })
      ]),
      _: 1
    })
  ], 64))
}
}

})